import { render, staticRenderFns } from "./questionPreview.vue?vue&type=template&id=6615fd3d&scoped=true&"
import script from "./questionPreview.vue?vue&type=script&lang=js&"
export * from "./questionPreview.vue?vue&type=script&lang=js&"
import style0 from "./questionPreview.vue?vue&type=style&index=0&id=6615fd3d&prod&lang=css&"
import style1 from "./questionPreview.vue?vue&type=style&index=1&id=6615fd3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615fd3d",
  null
  
)

export default component.exports